import { Component, inject } from '@angular/core';
import { Teacher } from '../interfaces/teacher';
import { ProjectCardComponent } from '../project-card/project-card.component';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { ref, getStorage, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Project } from '../interfaces/project';
import { DraftService } from '../services/draft.service';
import {TeacherService} from "../services/teacher.service";

@Component({
  standalone: true,
  selector: 'app-teachers',
  templateUrl: './teacher-profile.component.html',
  styleUrls: [
    './teacher-profile.component.css',
    '../app.component.css'
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ProjectCardComponent
]
})

export class TeachersComponent {
  schools : any [] = [];
  schoolProjects: Project[] = [];
  myProjects: Project[] = [];
  isEditing = false;
  userId: string | undefined = undefined;
  teacherImg: string = '';
  draftData: Project[] = [];

  constructor(
    private router: Router,
    private draftService: DraftService,
    private teacherService: TeacherService
  ) {};
  route: ActivatedRoute = inject(ActivatedRoute)
  userService = inject(UserService);
  teacher : Teacher = {
    img: "/assets/placeholderimg/placeholder.jpg",
    title: "",
    fName: "",
    mInitial: "",
    lName: "",
    email: "",
    school: "",
    grade: "",
    bio: "",
    projs: [""],
    role: "",
    isActive: true
  }

  teacherList: Teacher[] | null = [];

  onProjectCardClicked(id: any) {
    this.router.navigate(['/project', id]);
  }

  editProfile() {
    this.isEditing = !this.isEditing;
  }

  async ngOnInit(){
    await this.getSchools();
    this.teacherList = await this.teacherService.getAllTeachers() ?? [];
    this.filteredTeachers = [...this.teacherList];

    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user){
        if (auth.currentUser?.uid == undefined){
          console.log("undefined user");
        } else {
          this.userId = auth.currentUser.uid;
          await this.getTeacher();
          await this.getProjectLists();
          //await this.getDrafts();
        }
      } else {
        await this.router.navigate(['/landing']);
      }
    })
  }

  async getProjectLists() {
    const projectsRef = await firebase.firestore().collection('projects');

    let schoolQuery = projectsRef.where('visibility', 'in', ['Everyone', 'My School']);
    const schoolSnapshot = await schoolQuery.get();

    const allSchoolProjects = schoolSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data() as Project
    }));

    this.schoolProjects = allSchoolProjects.filter(project => project.school === this.teacher.school);

    if (this.userId) {
      let myProjectsQuery = projectsRef.where('owner', '==', this.userId).where("visibility", "==", "Only Me");
      const mySnapshot = await myProjectsQuery.get();
      const privateMyProjects = mySnapshot.docs.map(doc => ({id: doc.id, ...doc.data() as Project}));
      const publicMyProjects = allSchoolProjects.filter(project => project.owner == this.userId);
      this.myProjects = [...privateMyProjects, ...publicMyProjects]
    }
  }

  async getDrafts() {
    try {
      this.draftData = await this.draftService.getUserDrafts();
    } catch (error) {
      console.error('Error loading drafts:', error);
      this.draftData = [];
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString();
  }


  async getSchools(){
    const snapshot = await firebase.firestore().collection('school').get();
    snapshot.forEach((doc) => this.schools.push((doc.data())));
    this.schools.forEach((doc) => doc.name = doc.name + " School")
    this.schools.sort((a, b) => a.name.localeCompare(b.name));
    this.schools.splice(0, 0, {name: "All Schools", cluster: "All"})
  }

  async getTeacher(){
    const database = firebase.firestore();
    const firebaseDoc = database.collection("teacher").doc(this.userId);
    const docSnap = await firebaseDoc.get();
    const data = docSnap.data() as Teacher;

    this.teacher = data;
    const storage = getStorage();
    const gsRef = ref(storage, data.img);
    getDownloadURL(gsRef).then((url) => {
      this.teacherImg = url;
    })

    const titleInput = (document.querySelector("#titleInput") as HTMLSelectElement);
    if (!titleInput) {
      return;
    }

    for (let i = 0; i < titleInput.options.length; i++){
      if (titleInput.options[i].value == this.teacher.title){
        titleInput.options[i].selected = true;
      }
    }
    const schoolInput = (document.querySelector("#schoolInput") as HTMLSelectElement);
    for (let i = 0; i < schoolInput.options.length; i++){
      if (schoolInput.options[i].value == this.teacher.school){
        schoolInput.options[i].selected = true;
      }
    }
    const gradeInput = (document.querySelector("#gradeInput") as HTMLSelectElement);
    for (let i = 0; i < gradeInput.options.length; i++){
      if (gradeInput.options[i].value == this.teacher.grade){
        gradeInput.options[i].selected = true;
      }
    }
    const lNameInput = document.querySelector("#lNameInput");
    lNameInput?.setAttribute("value", this.teacher.lName);
    const mInitial = document.querySelector("#mInitialInput");
    mInitial?.setAttribute("value", this.teacher.mInitial);
    const fNameInput = document.querySelector("#fNameInput");
    fNameInput?.setAttribute("value", this.teacher.fName);
    const preferredCBs = (document.querySelectorAll(".preferredCB"));
    for (let i = 0; i < this.teacher.projs.length; i++){
      for (let j = 0; j < preferredCBs.length; j++){
        let checkbox = preferredCBs[j] as HTMLInputElement;
        if (checkbox.value == this.teacher.projs[i]){
          checkbox.setAttribute("checked", "true");
        }
      }
    }
    const bioInput = (document.querySelector("#bioInput") as HTMLTextAreaElement);
    bioInput.textContent = this.teacher.bio;

    const loadingMsg = document.querySelector('#loading') as HTMLDivElement;
    loadingMsg.classList.add("hidden");
    const profile = document.querySelector('#profile') as HTMLDivElement;
    profile.classList.remove("hidden");
  }

  updateProfile(){
    const metadata = {
      contentType: 'image/jpeg'
    }

    const title = (document.querySelector("#titleInput") as HTMLSelectElement).value;
    const lNameInput = (document.querySelector("#lNameInput") as HTMLInputElement).value;
    const mInitial = (document.querySelector("#mInitialInput") as HTMLInputElement).value;
    const fNameInput = (document.querySelector("#fNameInput") as HTMLInputElement).value;
    const bioInput = (document.querySelector("#bioInput") as HTMLTextAreaElement).value;
    const schoolInput = (document.querySelector("#schoolInput") as HTMLSelectElement).value;
    const gradeInput = (document.querySelector("#gradeInput") as HTMLSelectElement).value;
    firebase.firestore().collection('teacher').doc(this.userId).update({
      title: this.teacher.title,
      fName: this.teacher.fName,
      mInitial: this.teacher.mInitial,
      lName: this.teacher.lName,
      grade: this.teacher.grade,
      school: this.teacher.school,
      bio: this.teacher.bio,
    }).then(() => {
      this.isEditing = false;
    });

    //this.getTeacher();
    const image = document.querySelector("#profileImgInput") as HTMLInputElement;
    const storage = getStorage();
    const storageRef = ref(storage, 'profileImgs/' + this.userId);
    if (image.files && image.files?.length > 0){
      const uploadTask = uploadBytesResumable(storageRef, image.files[0], metadata);
      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("upload is " + progress + "% done");
        switch (snapshot.state){
          case 'paused':
            console.log("upload is paused");
            break;
          case 'running':
            console.log('upload in progress');
            break;
        }
      },
      (error) => {
        switch (error.code){
          case 'storage/unauthorized':
            console.log("User doesn't have permission to access the object");
            break;
          case 'storage/canceled':
            console.log("User canceled the upload");
            break;
        }
      },
      () => {
        console.log("upload complete");
        firebase.firestore().collection('teacher').doc(this.userId).update({
          img: 'profileImgs/' + this.userId,
        });
        this.getTeacher();
      })
    }
  }

  editingIndex: number | null = null;
  editTeacher!: Teacher;

  startEdit(index: number, teacher: Teacher) {
    this.editingIndex = index;
    this.editTeacher = { ...teacher };
  }

  setActivation(teacher: Teacher){
    const confirmAction = confirm(
      `Are you sure you want to ${teacher.isActive ? 'deactivate' : 'activate'} ${teacher.fName}?`
    );

    if (!confirmAction) return;

    const teachersRef = firebase.firestore().collection('teacher');

    teachersRef.where('email', '==', teacher.email).get()
      .then(snapshot => {
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          const newStatus = !teacher.isActive;

          doc.ref.update({ isActive: newStatus })
            .then(() => {
              console.log(`Teacher ${teacher.fName} is now ${newStatus ? 'active' : 'inactive'}`);
              teacher.isActive = newStatus;
            })
            .catch(err => console.error('Error updating teacher:', err));
        } else {
          console.log('No teacher found with this email');
        }
      })
      .catch(err => console.error('Error querying teacher:', err));
  }

  cancelEdit() {
    this.editingIndex = null;
  }

  async saveEdit() {
    if (this.editingIndex === null) return;

    const edited = this.editTeacher;

    // Find teacher by unique email instead of id
    const snapshot = await firebase.firestore()
      .collection('teacher')
      .where('email', '==', edited.email)
      .get();

    if (snapshot.empty) {
      console.error("No teacher found with this email");
      return;
    }

    const docRef = snapshot.docs[0].ref;
    await docRef.update({
      fName: edited.fName,
      lName: edited.lName,
      school: edited.school,
      grade: edited.grade,
      role: edited.role
    });

    this.teacherList![this.editingIndex] = { ...edited };
    this.editingIndex = null;
  }

  searchTerm: string = '';
  filteredTeachers: Teacher[] = [];

  onSearchChange() {
    const term = (this.searchTerm || '').toLowerCase();

    if (!this.teacherList) {
      this.filteredTeachers = [];
      return;
    }

    this.filteredTeachers = this.teacherList.filter(t =>
      (t.fName?.toLowerCase().includes(term) ||
        t.lName?.toLowerCase().includes(term) ||
        t.email?.toLowerCase().includes(term) ||
        t.school?.toLowerCase().includes(term) ||
        t.role?.toLowerCase().includes(term))
    );
  }
}
